import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";


function BulkFuelVendorView(props) {
  const { data } = props;
  console.log("kmmjeijrio",data)
  const navigate = useNavigate();

  let columns;
  {
    data?.map((i, k) => {
      columns = [
        {
          name: "Date",
          selector: (i) => i["date(DD-MM-YYYY)"],
          wrap: true,  // This will wrap the text within the cell
          style: {
            whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
            wordBreak: 'break-word',  // Break long words to fit within the cell
          }
        },
        {
          name: "Pump Name",
          selector: (i) => (
            <div>
              {i["Pump Name"]}
            </div>
          ),
          wrap: true,  // This will wrap the text within the cell
          style: {
            whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
            wordBreak: 'break-word',  // Break long words to fit within the cell
          }
        },
        {
          name: "Vehicle Number",
          selector: (i) => i["Vehicle Number"],
          wrap: true,  // This will wrap the text within the cell
          style: {
            whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
            wordBreak: 'break-word',  // Break long words to fit within the cell
          }
        },
        {
            name: "Litres",
            selector: (i) => i["litres"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
          {
            name: "Rate",
            selector: (i) => i["Rate"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
          {
            name: "Amount",
            selector: (i) => i["amount"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
          {
            name: "Report",
            selector: (i) => i["Report"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
          {
            name: "Remarks",
            selector: (i) => i["remarks"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
          {
            name: "RripNo",
            selector: (i) => i["tripNo"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
          {
            name: "Reference Id",
            selector: (i) => i["Reference Id"],
            wrap: true,  // This will wrap the text within the cell
            style: {
              whiteSpace: 'pre-wrap',  // Ensure the text wraps correctly
              wordBreak: 'break-word',  // Break long words to fit within the cell
            }
          },
      ];
    });
  }
  return (
    <div style={{ margin: "30px 50px 50px 50px" }}>
      <DataTable
        columns={columns}
        data={data}
        customStyles={{
          headRow: {
            style: {
              backgroundColor: "#ededf1",
              fontSize: "16px",
              fontWeight: "bold",
            },
          },
          headCells: {
            style: {
              fontWeight: "bold",
              textTransform: "uppercase",
              border: "1px solid rgba(108, 108, 108, 0.2)",
            },
          },
          cells: {
            style: {
              fontSize: "14px",
              minHeight: "50px",
              border: "1px solid rgba(108, 108, 108, 0.2)",
            },
          },
        }}
        // fixedHeader
        // fixedHeaderScrollHeight='450px'
        // selectableRows
        selectableRowsHighlight
        highlightOnHover
      />
    </div>
  );
}

export default BulkFuelVendorView;
